var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLSmartPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 30,
    viewBox: "0 0 21 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.015625 3.75C0.015625 1.68164 1.69727 0 3.76562 0H16.8906C18.959 0 20.6406 1.68164 20.6406 3.75V26.25C20.6406 28.3184 18.959 30 16.8906 30H3.76562C1.69727 30 0.015625 28.3184 0.015625 26.25V3.75ZM12.2031 26.25C12.2031 25.7527 12.0056 25.2758 11.6539 24.9242C11.3023 24.5725 10.8254 24.375 10.3281 24.375C9.83084 24.375 9.35393 24.5725 9.0023 24.9242C8.65067 25.2758 8.45312 25.7527 8.45312 26.25C8.45312 26.7473 8.65067 27.2242 9.0023 27.5758C9.35393 27.9275 9.83084 28.125 10.3281 28.125C10.8254 28.125 11.3023 27.9275 11.6539 27.5758C12.0056 27.2242 12.2031 26.7473 12.2031 26.25ZM16.8906 3.75H3.76562V22.5H16.8906V3.75Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLSmartPhoneIcon);
export default __webpack_public_path__ + "static/media/l_smartPhone_icon.1ef2455f8d2ac2a7e43424d3dd7db374.svg";
export { ForwardRef as ReactComponent };